import { continents } from './continentData';
import { countries } from './countryData';
import { destinations } from './destinationData';
import { areaDestinations } from './areaDestinationData';

const processData = () => {
    // Map for quick lookup
    const countriesMap = Object.fromEntries(countries.map(country => [country.id, country]));
    const destinationsMap = Object.fromEntries(destinations.map(destination => [destination.id, destination]));
    const areaDestinationsMap = Object.fromEntries(areaDestinations.map(areaDestination => [areaDestination.id, areaDestination]));
  
    // Link destinations with areaDestinations
    destinations.forEach(destination => {
      destination.areaDestinations = destination.areaDestinationIds.map(id => areaDestinationsMap[id]);
    });
  
    // Link countries with destinations
    countries.forEach(country => {
      country.topDestinations = country.topDestinationIds.map(id => destinationsMap[id]);
    });
  
    // Link continents with countries
    continents.forEach(continent => {
      continent.countries = continent.countryIds.map(id => countriesMap[id]);
    });
  
    return continents;
  };
  
  export { processData };
